import { useRef, useEffect } from 'react'
import { search } from 'assets/Icons'
import { Props as SelectProps, StylesConfig, components } from 'react-select'
import { useField } from '@unform/core'
import { InputContainer } from 'styles/index'
import { Select, SelectContainer, Span, InputError } from './style'

interface ISelectProps extends SelectProps {
  name: string
  icon?: string
  placeholder?: string
  disabled?: boolean
  value?: any
  small?: boolean
  xsmall?: boolean
  large?: boolean
  marginRight?: number
  searchbar?: boolean
  onChange?: (_ev: any) => void
  uniqKey?: string
  isClearable?: boolean
}

interface ColourOption {
  readonly isDisabled?: boolean
}

const Control = ({ children, ...props }: any) => {
  return (
    <components.Control {...props}>
      <img className="sb-img" src={search} alt="search icon" />
      {children}
    </components.Control>
  )
}

export default function SelectComponent(props: ISelectProps) {
  const {
    name,
    placeholder,
    isMulti,
    disabled,
    small,
    value,
    searchbar,
    xsmall,
    large,
    uniqKey,
    isClearable,
  } = props
  const { onChange, defaultValue: _defaultValue } = props
  const selectRef: any = useRef<HTMLSelectElement>(null)
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name)

  const colourStyles: StylesConfig<ColourOption> = {
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#cdcac5 !important' : '#fbfbfb',
        color: 'black',
        padding: '5px',
        textOverflow: 'ellipsis',
        zIndex: 40,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }
    },
    dropdownIndicator: (provided) => ({
      ...provided,
      display: searchbar ? 'none' : 'visible', // Hides the dropdown indicator
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute', // Posiciona o menu com position absolute
      zIndex: 9999, // Certifique-se de que está acima de outros elementos
      marginTop: 0, // Remove margens adicionais
    }),
    menuList: (base) => ({
      ...base,
      zIndex: 40,
      position: 'absolute',
      // width: small ? '90px' : '253px',
      '::-webkit-scrollbar': {
        width: '8px',
        backgroundColor: '#C4C4C4',
        borderRadius: '50px',
      },
      '::-webkit-scrollbar-track': {
        background: '#fbfbfb',
        border: 0,
      },
      '::-webkit-scrollbar-thumb': {
        width: '8px',
        backgroundColor: '#C4C4C4',
        borderRadius: '50px',
      },
    }),
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (isMulti) {
          if (!ref.state.selectValue) {
            return []
          }
          return ref.state.selectValue.map((option: any) => option.value)
        }
        if (!ref.state.selectValue[0]) {
          return ''
        }
        return ref.state.selectValue[0].value
      },
    })
  }, [fieldName, registerField, isMulti])

  // const getWidth = () => {
  //   if (xsmall) return 84
  //   if (small) return 90
  //   if (large) return 144
  //   return 252
  // }

  // useEffect(() => {
  //   selectRef.current.value = null
  // }, [])

  useEffect(() => {
    if (value) return clearError()
  }, [value])

  return (
    <InputContainer smallHeight>
      {value ? <Span>{placeholder}</Span> : <div />}
      <SelectContainer>
        <Select
          isClearable={isClearable}
          key={uniqKey}
          onFocus={clearError}
          placeholder={placeholder || 'Selecione...'}
          defaultValue={defaultValue}
          ref={selectRef}
          classNamePrefix="Select"
          error={error}
          styles={colourStyles}
          isDisabled={disabled}
          onChange={(obj: any) => {
            clearError()
            onChange && onChange(obj)
          }}
          isSearchable={searchbar}
          components={searchbar ? { Control } : undefined}
          {...props}
        />
        {error && (
          <InputError xsmall={xsmall} small={small} large={large}>
            {error}
          </InputError>
        )}
      </SelectContainer>
    </InputContainer>
  )
}
